module.exports = __webpack_public_path__ + "img/main.971e2e48.png";